"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryElement = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _objectSpread4 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _ProductImage = require("../../atoms/ProductImage");

var _CheckBox = require("../../atoms/CheckBox");

var _GeneralButton = require("../../atoms/GeneralButton");

var _ValidationPanel = require("../../atoms/ValidationPanel");

var _react = require("react");

var _Select = _interopRequireDefault(require("../../atoms/Select"));

var _rejectIcon = _interopRequireDefault(require("../../../assets/images/generalButton/rejectIcon.svg"));

var _acceptIcon = _interopRequireDefault(require("../../../assets/images/generalButton/acceptIcon.svg"));

var _Tooltip = require("../../atoms/Tooltip");

var _jsxRuntime = require("react/jsx-runtime");

var GalleryElement = function GalleryElement(_ref) {
  var _auditImages$values$n, _auditImages$values$n2;

  var image = _ref.image,
      _ref$gridLayout = _ref.gridLayout,
      gridLayout = _ref$gridLayout === void 0 ? false : _ref$gridLayout,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "chk-default" : _ref$id,
      label = _ref.label,
      number = _ref.number,
      imageInputs = _ref.imageInputs,
      imageType = _ref.imageType,
      imagePackagingType = _ref.imagePackagingType,
      changeImage = _ref.changeImage,
      selectedImages = _ref.selectedImages,
      setSelectedImages = _ref.setSelectedImages,
      setCheckAll = _ref.setCheckAll,
      auditImages = _ref.auditImages,
      compare = _ref.compare,
      updateApprovedInputsImages = _ref.updateApprovedInputsImages;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showValidationPanel = _useState2[0],
      setShowValidationPanel = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      showDivStates = _useState4[0],
      setShowDivStates = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      imageStates = _useState6[0],
      setImageStates = _useState6[1];

  var handleImgClick = function handleImgClick(inputId) {
    setShowDivStates(function (prevStates) {
      return (0, _objectSpread4.default)((0, _objectSpread4.default)({}, prevStates), {}, (0, _defineProperty2.default)({}, inputId, !prevStates[inputId]));
    });
  };

  var changeImageBtn = function changeImageBtn(inputId, action) {
    setImageStates(function (prevStates) {
      return (0, _objectSpread4.default)((0, _objectSpread4.default)({}, prevStates), {}, (0, _defineProperty2.default)({}, inputId, action === "validate"));
    });
    updateApprovedInputsImages(inputId);
  };

  var closeValidationPanel = function closeValidationPanel(e) {
    if (!e.target.closest("#validation-panel") || e.target.closest(".validation-option") && showValidationPanel) {
      document.removeEventListener("click", closeValidationPanel, false);
      setShowValidationPanel(false);
    }
  };

  var checkOnChange = function checkOnChange(e) {
    var chkGlobal = document.getElementById("check-all-images");
    var checkboxList = document.querySelectorAll("[id^='gallery-element-']");
    var temp = selectedImages.slice();
    e.target.checked ? temp.push(image) : temp = temp.filter(function (img) {
      return image.id !== img.id;
    });
    var counter = 0;
    checkboxList === null || checkboxList === void 0 ? void 0 : checkboxList.forEach(function (chk) {
      return chk.checked && counter++;
    });
    chkGlobal.checked = checkboxList.length === counter;
    setCheckAll(checkboxList.length === counter);
    setSelectedImages(temp);
  };

  (0, _react.useEffect)(function () {
    if (showValidationPanel) {
      document.addEventListener("click", closeValidationPanel, false);
    }
  }, [showValidationPanel]);

  var isEquals = function isEquals(value, auditValue) {
    return value === auditValue;
  }; //TOMAR EL image_id


  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    className: "".concat(gridLayout ? "grid-gallery" : "row-gallery", " ").concat(compare && !isEquals(image === null || image === void 0 ? void 0 : image.uuid, auditImages === null || auditImages === void 0 ? void 0 : (_auditImages$values$n = auditImages.values[number]) === null || _auditImages$values$n === void 0 ? void 0 : _auditImages$values$n.uuid) ? "audit-class" : ""),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "buttons-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.CheckBox, {
        id: id,
        label: label,
        onChange: function onChange(e) {
          return checkOnChange(e);
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "image-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductImage.ProductImage, {
        img: compare ? auditImages === null || auditImages === void 0 ? void 0 : (_auditImages$values$n2 = auditImages.values[number]) === null || _auditImages$values$n2 === void 0 ? void 0 : _auditImages$values$n2.src : image === null || image === void 0 ? void 0 : image.src,
        altText: image === null || image === void 0 ? void 0 : image.altText,
        imageType: "catalogue-image-".concat(gridLayout ? "big" : "small", "-size")
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "information-container",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: image === null || image === void 0 ? void 0 : image.name
        }), !gridLayout && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            children: [image.width, "x", image.height]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: image.ext
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.CheckBox, {
            className: "center",
            id: "has-description-".concat(image.id),
            defaultChecked: image.has_leyend,
            onChange: function onChange(e) {
              changeImage({
                action: "changeImageInfo",
                attribute: "has_leyend",
                value: e.target.checked,
                index: number
              });
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
            width: "100%",
            placeholder: "Tipo de toma",
            options: imageInputs === null || imageInputs === void 0 ? void 0 : imageInputs.filter(function (img) {
              return img.value === image.image_id || !img.active;
            }),
            valueSelected: image.image_id,
            onChange: function onChange(e) {
              changeImage({
                action: "changeImageInfo",
                attribute: "image_id",
                value: +e.target.value,
                index: number
              });
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
            width: "100%",
            placeholder: "Tipo de imagen",
            options: imageType,
            valueSelected: image.image_type,
            onChange: function onChange(e) {
              changeImage({
                action: "changeImageInfo",
                attribute: "image_type",
                value: +e.target.value,
                index: number
              });
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
            width: "100%",
            placeholder: "Tipo de empaque",
            options: imagePackagingType,
            valueSelected: image.packing_type,
            onChange: function onChange(e) {
              changeImage({
                action: "changeImageInfo",
                attribute: "packing_type",
                value: +e.target.value,
                index: number
              });
            }
          }), (image === null || image === void 0 ? void 0 : image.isApproved) === false && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: "flex",
              "justify-content": "center",
              "align-items": "center"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
              componentTooltip: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
                    children: "Comentarios:"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  children: image.comment
                })]
              }),
              children: !image.isApproved && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: imageStates[image.image_id] ? _acceptIcon.default : _rejectIcon.default,
                alt: "botón rechazar",
                style: {
                  cursor: "pointer"
                },
                onClick: function onClick() {
                  return handleImgClick(image.image_id);
                }
              }),
              classNameTooltip: "container-tooltip"
            }), showDivStates[image.image_id] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "btnReviewState",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
                  id: "aceptbtn",
                  onClick: function onClick() {
                    return changeImageBtn(image.image_id, "validate");
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: _acceptIcon.default,
                    alt: "acept button",
                    style: {
                      cursor: "pointer"
                    }
                  }), "Validar"]
                })
              })
            })]
          })]
        })]
      })]
    })]
  });
};

exports.GalleryElement = GalleryElement;